/*
 * Copyright (c) 2022-2023. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'
import Servant from '@/model/dataLayer/api/tableAndPerson/Servant'
import CashBox from '@/model/dataLayer/api/CashBox/CashBox'

const entity = {
  createdAt: {
    type: IKDataEntity.Types.String,
    form: false
  },
  cashBoxId: {
    displayName: 'CashBox',
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: async () => await CashBox.getList(true)
      }
    }
  },
  startAmount: {
    type: IKDataEntity.Types.String,
    form: false
  },
  diffAmount: {
    type: IKDataEntity.Types.String,
    form: false
  },
  endAmount: {
    type: IKDataEntity.Types.String,
    form: false
  },

  servantId: {
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: async () => await Servant.getList(true)
      }
    }
  },
  rePrint: {
    displayName: 'reprint',
    type: IKDataEntity.Types.Integer,
    form: false,
    tableConfig: {
      overwrite: true
    }
  }
}
const config = {
  load: async function () {
    return (await hillo.get('CashBoxController.php?op=getCashBoxSummaryLogList', {}))
      .content
  },
  add: async function (item) {
    return (await hillo.post('CashBoxController.php?op=createSummaryLog', {
      ...item
    }))
  }
}

export default IKDataEntity.ModelFactory(entity, config)

export async function reprintSettlement (id) {
  return (await hillo.post('CashBoxController.php?op=routeReprintFullSummaryLog', {
    summaryLogId: id
  }))
}
